import { LAND_TO_ELEMENT_KEY, RESPONSIVE_OFFSET } from './constants-es';

const FALLBACK_ELEMENT_CLASSNAME = '.lvbg-j-strip-label';

/**
 * Set storage to let Editorial anchor to a specific post on the linked page
 * @param postId
 */
export const setLandToElement = (postId: string) => {
  localStorage.setItem(
    LAND_TO_ELEMENT_KEY,
    JSON.stringify({
      elementId: postId,
      fallbackElementClassname: FALLBACK_ELEMENT_CLASSNAME,
      responsiveOffset: RESPONSIVE_OFFSET,
    })
  );
};
